import { Tracker } from './tracker';
import { User } from './user';

export class TrackerLockEvent {
    id: number;
    tracker:Tracker;
    user:User;
    dtLog:Date;
    isLock:boolean;
    isEventComplete:boolean;
    dtEventComplete:Date;
    message:string;

    constructor (id: number,
        tracker:Tracker,
        user:User,
        dtLog:Date,
        message:string,
        isLock:boolean,
        isEventComplete:boolean,
        dtEventComplete:Date) {

        this.id = id;
        this.tracker = tracker;
        this.user = user;
        this.dtLog = dtLog;
        this.message = message;
        this.isLock = isLock;
        this.isEventComplete = isEventComplete;
        this.dtEventComplete = dtEventComplete;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/tracker-lock-event.ts